import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { ImpactReportData, ImpactReportState } from 'store/impactReport/types';

export const getImpactReportState = (state: RootState): ImpactReportState => state.impactReport;

export const getImpactReportData = createSelector(
  [getImpactReportState],
  (state: ImpactReportState): ImpactReportData | null =>
    !state?.data
      ? null
      : {
          ...state?.data,
          // Stored in cents.
          donation_amount_total: state.data.donation_amount_total / 100,
          donation_amount_total_adjusted: state.data.donation_amount_total_adjusted / 100,
        }
);
